import { type FC } from 'react';
import StarIcon from '@assets/img/icons/star.svg?react';
import { type GoodsType } from '@common/types/goods';
import { StringXSmall } from '@components/Typography/Typography';
import { StorageIndicator } from '@components/ui/StorageIndicator/StorageIndicator';

import { CircleProductionProgress } from '@/components/ui/CircleProductionProgress/CircleProductionProgress';

import { GoodsItem } from '../GoodsItem/GoodsItem';

interface GoodsSelectionProps {
  name: GoodsType;
  size: {
    width: string;
    height: string;
  };
  lvl?: number;
  className?: string;
  withStar?: boolean;
  productionPercentage?: number;
}

const GoodsSelection: FC<GoodsSelectionProps> = ({
  size,
  name,
  lvl,
  className,
  withStar,
  productionPercentage,
}) => {
  return (
    <GoodsItem
      variant="dark-60-blur"
      radius="default"
      size={size}
      kind={name}
      className={className}
    >
      {lvl ? (
        <div className="absolute flex right-[4px] bottom-[4px] bg-main-bg/80 p-1 rounded-md">
          <StringXSmall
            weight="bold"
            className="!text-white/60"
          >{`lvl.${lvl}`}</StringXSmall>
        </div>
      ) : (
        <StorageIndicator
          className="absolute right-[4px] bottom-[4px]"
          resource={name}
        />
      )}
      {withStar && (
        <StarIcon className="absolute top-[4px] right-[4px] w-3 h-3 shrink-0 text-gold" />
      )}
      {productionPercentage != null && (
        <CircleProductionProgress
          percentage={productionPercentage}
          className="absolute top-[4px] left-[4px]"
        />
      )}
    </GoodsItem>
  );
};

export { GoodsSelection };
